import { useQuery } from "@tanstack/react-query";

import { fetchDataGet } from "@/core/api/api-methods";
import { QUERY_KEYS } from "@/core/api/query-keys";
import type { ReportingService } from "@/features/reporting/api/endpoints";
import { reportingEndpoints } from "@/features/reporting/api/endpoints";
import type { ReportingRangeParams } from "@/features/reporting/api/dto";
import {
  compactQuery,
  parseSummary,
} from "@/features/reporting/api/parse";

/** Totaux de période + jauges (`GET .../Reporting/summary`). */
export const useReportingSummary = (
  service: ReportingService,
  params: ReportingRangeParams = {},
  enabled = true
) =>
  useQuery({
    queryKey: QUERY_KEYS.REPORTING_SUMMARY(service, params.from, params.to),
    queryFn: async () => {
      const raw = await fetchDataGet<unknown>({
        url: reportingEndpoints[service].summary,
        queryParams: compactQuery({ from: params.from, to: params.to }),
      });
      return parseSummary(raw);
    },
    retry: (failureCount, error) =>
      !/401|403/.test(error?.message ?? "") && failureCount < 1,
    staleTime: 5 * 60 * 1000,
    enabled: enabled && Boolean(service),
  });
